import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";
import { useUserService } from "contexts/ServiceProvider";
import { GET_USERS_QUERY_KEY } from "./useUsersList";
import { GET_USER_DETAILS_QUERY_KEY } from "./useUserDetails";
import { GET_FARM_USERS_QUERY_KEY } from "./useFarmUsersList";

const useDeleteUser = (
  id: string,
  options: Omit<UseMutationOptions, "mutationKey" | "mutationFn">
) => {
  const userService = useUserService();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["delete-user", { id }],
    mutationFn: () => userService.deleteUser(id),
    ...options,
    onSuccess: (data, variables, context) => {
      return Promise.all([
        options.onSuccess?.(data, variables, context),
        queryClient.invalidateQueries({
          queryKey: [GET_USERS_QUERY_KEY],
        }),
        queryClient.invalidateQueries({
          queryKey: [GET_USER_DETAILS_QUERY_KEY, { id }],
        }),
        queryClient.refetchQueries({
          queryKey: [GET_FARM_USERS_QUERY_KEY, { id }],
        }),
      ]);
    },
  });
};

export default useDeleteUser;
